export default __webpack_public_path__ + "images/a75f978b6e7260df2f65b462fe62321f-visa@2x.png";